<template>
  <div>
    <data-form
      ref="searchForm"
      :content="searchContent"
      :data="searchFormData"
      :fixedLabelWidth="true"
      :colnum="6"
      :showButton="false"
      style="width:100%;"
    >
      <template slot="search">
        <a-button style="margin-left:10px;" type="primary" @click="handleSearch"
          >搜索</a-button
        >
        <a-button style="margin-left:10px;" type="primary" @click="handleAdd"
          >新增</a-button
        >
      </template>
    </data-form>
    <a-tabs defaultActiveKey="" @change="tabChange">
      <a-tab-pane tab="全部订单" key=""></a-tab-pane>
      <a-tab-pane tab="已确认" key="1"></a-tab-pane>
      <a-tab-pane tab="未确认" key="0"></a-tab-pane>
      <a-tab-pane tab="取消" key="2"></a-tab-pane>
    </a-tabs>
    <data-grid
      ref="dataGrid"
      :columns="columns"
      api="Warehouse_BillPageGet"
      v-model="data"
      :params="params"
      :pagination="true"
      :props="props"
      bordered
    >
      <template slot="rowAction" slot-scope="text, record">
        <a-button
          type="link"
          size="small"
          @click="orderDetail(record)"
          v-if="record.Status == 0"
          >编辑</a-button
        >
        <span v-if="record.Status == 0">|</span>
        <a-popconfirm
          title="确认操作吗?"
          @confirm="handleConfirm(record)"
          okText="确认"
          cancelText="取消"
          v-if="record.Status === 0"
        >
          <a-button type="link" size="small">确认 |</a-button>
        </a-popconfirm>
        <a-popconfirm
          title="确认取消吗?"
          @confirm="handleCancel(record)"
          okText="确认"
          cancelText="取消"
          v-if="record.Status == 0"
        >
          <a-button type="link" size="small">取消</a-button>
        </a-popconfirm>
        <!-- <a-button type="link" size="small">补打</a-button>|
        <a-button type="link" size="small">日志</a-button> -->
      </template>
    </data-grid>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import { DataForm } from "@/components/dataForm";
import { mixin } from "./mixin";
export default {
  name: "Transfer",
  components: {
    DataGrid,
    DataForm
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      params: { BillType: 4, Status: null },
      type: "transfer"
    };
  },
  created() {},
  methods: {
    handleSearch(type) {
      this.search(4, type);
    },
    handleAdd() {
      const json = {
        api: "Transfer_Add",
        type: "transfer",
        actionType: "add",
        update: () => {
          this.handleSearch("add");
        }
      };
      this.add(json);
    },
    handleConfirm(record) {
      this.confirm("Transfer_Confirm", record.Id);
    },
    handleCancel(record) {
      this.cancel("Transfer_Cancel", record.Id);
    },
    orderDetail(record) {
      this.checkDetail(record, "Transfer_Edit", "transfer");
    }
  }
};
</script>

<style lang="less" scoped>
.data-form-box /deep/ .fixed-label-width .ant-form-item .ant-form-item-label {
  width: 80px;
}
</style>
